import styled from "styled-components";

export const FullWidth = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 25px;
  height: 100%;
  width: 100%;
  color: ${({ theme }) => theme.colors.contentSubtle};
`;
